import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { defineChain } from 'viem'
import { http } from 'wagmi'

import { Env } from '@/lib/env'

export const saharaTestnet = defineChain({
  id: 313313,
  name: 'Sahara AI Testnet',
  nativeCurrency: {
    name: 'Sahara AI Token',
    symbol: 'SAHARA',
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ['https://testnet.saharalabs.ai'] },
  },
  blockExplorers: {
    default: {
      name: 'Sahara Testnet Explorer',
      url: 'https://testnet-explorer.saharalabs.ai',
    },
  },
  testnet: true,
})

export const saharaMainnet = defineChain({
  id: 3132023,
  name: 'Sahara AI Mainnet',
  network: 'sahara',
  nativeCurrency: {
    name: 'Sahara AI Token',
    symbol: 'SAHARA',
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ['https://mainnet.saharalabs.ai'] },
  },
  blockExplorers: {
    default: {
      name: 'Sahara Mainnet Explorer',
      url: 'https://explorer.saharalabs.ai',
    },
  },
})

export const getWagmiConfig = (env: Env) => getDefaultConfig({
  appName: 'AxGrad',
  projectId: 'e0e476af3d3b5837f2e4130770952876',
  chains: env === Env.Production ? [saharaTestnet] : [saharaTestnet],
  transports: {
    [saharaMainnet.id]: http(),
    [saharaTestnet.id]: http(),
  },
  ssr: true,
})
